/**
 * Warnton für kritische Benachrichtigungen (zwei kurze Beeps über die Web Audio API).
 *
 * Ersetzt die Sound-Logik des früheren rideMonitoringService: Die Auslösung
 * kommt jetzt aus dem Firestore-Notifications-Listener (serverseitige Events
 * mit data.priority === 'critical'), nicht mehr aus einem eigenen Polling.
 *
 * Browser sperren AudioContext bis zur ersten Benutzerinteraktion — in dem
 * Fall wird der Ton bei der nächsten Interaktion nachgeholt.
 */
class AlertSoundService {
  constructor() {
    this.audioContext = null;
  }

  playAlertSound() {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return;

      if (!this.audioContext) {
        this.audioContext = new AudioContextClass();
      }

      if (this.audioContext.state === 'suspended') {
        const enableAudio = () => {
          this.audioContext.resume().then(() => this.playBeepSound());
          document.removeEventListener('click', enableAudio);
          document.removeEventListener('keydown', enableAudio);
        };
        document.addEventListener('click', enableAudio, { once: true });
        document.addEventListener('keydown', enableAudio, { once: true });
        return;
      }

      this.playBeepSound();
    } catch (error) {
      console.error('Fehler beim Abspielen des Warntons:', error);
    }
  }

  playBeepSound() {
    try {
      this.playBeep(800);
      setTimeout(() => {
        if (this.audioContext && this.audioContext.state === 'running') {
          this.playBeep(600);
        }
      }, 200);
    } catch (error) {
      console.error('Fehler beim Beep-Sound:', error);
    }
  }

  playBeep(frequency) {
    const oscillator = this.audioContext.createOscillator();
    const gainNode = this.audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(this.audioContext.destination);

    oscillator.frequency.setValueAtTime(frequency, this.audioContext.currentTime);
    oscillator.type = 'sine';

    gainNode.gain.setValueAtTime(0.3, this.audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.5);

    oscillator.start(this.audioContext.currentTime);
    oscillator.stop(this.audioContext.currentTime + 0.5);
  }
}

const alertSoundService = new AlertSoundService();

export default alertSoundService;
